import { BusinessPerfMetric, PlatformPerfMetric } from './enums';

// https://apms.shopee.io/apps/tob-account-non-live/custom/group/b91ce806aa3d824f6546172503ee979f
export const PLATFORM_METRIC_POINT_MAPPING: Record<string, string> = {
  [PlatformPerfMetric.AppInit]: 'b66484f27890770b264023a06e715502',
  [PlatformPerfMetric.AppRendered]: '26c90ef63083832b2971a6a3f6f73e0a',
  [PlatformPerfMetric.WebBridgeCall]: '6dddc5333a32bf36a06fc7339cbecd9d',
};

export const DEFAULT_BUSINESS_METRIC_POINT_MAPPING: Record<string, string> = {
  // Track when page hero component is did mount
  // https://apms.shopee.io/apps/tob-account-non-live/custom/group/7732ff62d18e9f5e9da1376dbfee3c64
  [BusinessPerfMetric.PageLoad]: 'd43f46bd430fb83a36c9cfa90e6ac51c',
  // https://apms.shopee.io/apps/tob-account-non-live/custom/group/7846848e9c4656b814a0bd5e74ac77b0
  [BusinessPerfMetric.GTMEventReport]: 'e684107601fdccf6a8053a11fec0d68d',
  [BusinessPerfMetric.OneCredentialDelinkInit]:
    '789d2fa9001db331d3e394869f975525',
  [BusinessPerfMetric.OneCredentialDelinkErrorPage]:
    '5dc30bd2013505e815e0901de7d1dcbd',
  [BusinessPerfMetric.OneCredentialDelinkCommit]:
    'bcda5a530a46ee7c11d78a5fd7c8dfd3',
  [BusinessPerfMetric.ThirdPartyAccountAttemptLogin]:
    '52dcc48f9960e7c57d5849b439911f45',
  [BusinessPerfMetric.ThirdPartyAccountLogin]:
    '9bd19ac9fb7649fbd6b8dc001eaa5168',
  [BusinessPerfMetric.ThirdPartyAccountAttemptLink]:
    'f5c1b0ff820eb93ab6e350cd6860a85b',
  [BusinessPerfMetric.ThirdPartyAccountLinkOrUnlink]:
    '62e30ad5aae0d998f2e4a4d051cb8c7b',
  [BusinessPerfMetric.NeedIvsLoginTriggered]:
    '776c74c7c3b589fe69981492fa43ceda',
  [BusinessPerfMetric.LoginByIvsSuccess]: '4b321318991153a6da35566d32c83f99',
  [BusinessPerfMetric.LoginByIvsFailed]: '3d874c81a43793f6c56ac5c87911f360',
  // https://apms.shopee.io/apps/tob-account-non-live/custom/group/773ba4fe0dfe818e0fdf8607b6576c5b?from=1759129268&tab=custom-accum&to=1759734068
  [BusinessPerfMetric.SubmitPassword]: '370adcef4d410090b93f85950f28cd29',
  [BusinessPerfMetric.LoginByPasswordResult]:
    '702083b1ed212b939cc6239037b0a229',
  [BusinessPerfMetric.LoginResult]: '21ba6a11e9e41ed5eb114c7385d271dc',
  // TODO(dev): fill APMS point ID once minted in the tob-account APMS app
  [BusinessPerfMetric.SignupResult]: '',
};
